import { getAPI } from "../../../api";
import { REACT_APP_CUSTOMER } from "../../../utils/common"


export async function getUserDetails(email: string) {
    const Details = getAPI( REACT_APP_CUSTOMER + `/email-validation/${email}?customerType=2`);
    return Details;
}

